import { By, WebElementPromise } from 'selenium-webdriver';
import { CollapsibleWebElementBase } from './CollapsibleWebElementBase';

/**
 * The component WebElement for [oj-c-collapsible](../../jsdocs/oj-c.Collapsible.html).
 * Do not instantiate this class directly, instead, use
 * [findCollapsible](../functions/findCollapsible.html).
 */
export class CollapsibleWebElement extends CollapsibleWebElementBase {
  private toggleButton: WebElementPromise | undefined;

  /**
   * Collapse the content. If already collapsed, this method will do nothing.
   * @returns Promise<void>
   */
  async doCollapse() {
    if (await this.getExpanded()) {
      return (await this.getToggleButton()).click();
    }
  }
  /**
   * Expand the content. If already expanded, this method will do nothing.
   * @returns Promise<void>
   */
  async doExpand() {
    if (!(await this.getExpanded())) {
      return (await this.getToggleButton()).click();
    }
  }

  private getToggleButton(): WebElementPromise {
    if (!this.toggleButton) {
      this.toggleButton = this.findElement(
        // Need to use Xpath to partial-match header Id
        By.xpath(
          './/*[starts-with(@id, "oj-collapsible-header-")]/*/*[starts-with(@aria-labelledby, "oj-collapsible-header-")]'
        )
      );
    }
    return this.toggleButton;
  }
}
